import React, { useEffect, useState } from 'react';
import Metadata from "./components/page/Metadata";
import Userdetails from "./components/page/Userdetails";
import Projectrestriction from "./components/page/Projectrestriction";

const ModalManager = ({
  value1,
  value2,
  values,
  pbuDetail,
  vgrpDetail,
  projAsis,
  projMem,
  vgrpVal,
  pbuVal,
}) => {

  //const [fromCRMprojid,setfromCRMprojid]=useState('');
  const [radiovalue, setRadiovalue] = useState("CRM");
  const [step, setStep] = useState(1);
  const [searchVal, setSearchVal] = useState("");
  const [textValue1, setTextValue1] = useState("No Selection");
  const [textValue2, setTextValue2] = useState("");
  const [confidentialValue, setconfidentialValue] = useState(false);
  const [dataResident, setdataResident] = useState("");
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [currentPage, setCurrentPage] = useState('Userdetails');
  
 const handleSaveCheckboxes = (value1, value2) => {
  setSelectedCheckboxes(value1);
  
  values.confidential = value1;
  values.dataResidency = value2 ? "UK" : "";

  if (value1) {
    setTextValue1("Confidential - Yes");
    setconfidentialValue(true);
  } else {
    setTextValue1("Confidential - No");
    setconfidentialValue(false);
  }
  
  if (value2) {
    setTextValue2("UK Data Residency - Yes");
    setdataResident("UK");
  } else {
    setTextValue2("UK Data Residency - No");
    setdataResident("");
  }
  
  prevStep();
};


 

  // go back to previous step
  const prevStep = () => {
    setStep(step - 1);
  };

  // proceed to the next step
  const nextStep = () => {
    setStep(step + 1);
  }; 
    
  return (
    <>
              {step === 1 ? (
                <Metadata
                  nextStep={nextStep} // action on next button click
                  values={values} //Values to be carryed out all the screen
                 // closeFn={closeFn} //Close function
                  pbuDetail={pbuDetail} //Carry out PBU values from API call
                  vgrpDetail={vgrpDetail} //Carry out viewer group values API call
                  projAsis={projAsis} //Set project assistant variable
                  projMem={projMem} //Set Member variables
                  vgrpVal={vgrpVal} //Set Viewer group variables
                  pbuVal={pbuVal} //Set PBU variable that selected from project
                  radiovalue={radiovalue} //set radio button selection
                  setRadiovalue={setRadiovalue} //Check for radio button
                  searchVal={searchVal} //Set search value
                  setSearchVal={setSearchVal} //Get searched value
                  //fromCRM={fromCRM} //Check if it's from CRM project
                  //fromCRMisProj={fromCRMisProj}//Check if it's from CRM project if express
                  //metadataVal ={metadataVal} //Get all metadata values
                  //fromMAC={fromMAC}
                  setTextValue1={setTextValue1}
  setTextValue2={setTextValue2}
                />
              ) : (
                ""
              )}
              {step === 2 ? (
                <Userdetails
                  prevStep={prevStep} //Action when previous button click
                  nextStep={nextStep} // action on next button click
                  values={values} //Values to be carryed out all the screen
                  //closeFn={closeFn} //Close function
                  pbuDetail={pbuDetail} //Carry out PBU values from API call
                  vgrpDetail={vgrpDetail} //Carry out viewer group values API call
                  projAsis={projAsis} //Set project assistant variable
                  projMem={projMem} //Set Member variables
                  vgrpVal={vgrpVal} //Set Viewer group variables
                  pbuVal={pbuVal} //Set PBU variable that selected from project
                  radiovalue={radiovalue} //set radio button selection
                  setRadiovalue={setRadiovalue} //Check for radio button
                  searchVal={searchVal} //Set search value
                  setSearchVal={setSearchVal} //Get searched value
                  textValue1={textValue1}
                  setTextValue1={setTextValue1}
                  textValue2={textValue2}
                  setTextValue2={setTextValue2}
                  confidentialValue={confidentialValue}
                  setconfidentialValue={setconfidentialValue}
                  dataResident={dataResident}
                  setdataResident={setdataResident}
                  
                />
              ) : (
                ""
              )}
              {step === 3 ? (
                <Projectrestriction
                  prevStep={prevStep} //Action when previous button click
                  nextStep={nextStep} // action on next button click
                  values={values} //Values to be carryed out all the screen
                  //closeFn={closeFn} //Close function
                  pbuDetail={pbuDetail} //Carry out PBU values from API call
                  vgrpDetail={vgrpDetail} //Carry out viewer group values API call
                  projAsis={projAsis} //Set project assistant variable
                  projMem={projMem} //Set Member variables
                  vgrpVal={vgrpVal} //Set Viewer group variables
                  pbuVal={pbuVal} //Set PBU variable that selected from project
                  radiovalue={radiovalue} //set radio button selection
                  setRadiovalue={setRadiovalue} //Check for radio button
                  searchVal={searchVal} //Set search value
                  setSearchVal={setSearchVal} //Get searched value
                  selectedValues={selectedCheckboxes}
                  setSelectedCheckboxes={setSelectedCheckboxes}
                  onSave={handleSaveCheckboxes}
                />
              ) : (
                ""
              )}
    </>
  );
};

export default ModalManager;


